import React, { useState } from 'react';
type ToggleActiveProps = {
  onChange: (isActive: boolean) => void;
};

const ToggleActive: React.FC<ToggleActiveProps> = ({ onChange }) => {
  const [enabled, setEnabled] = useState(true);

  const handleToggle = () => {
    const newValue = !enabled;
    setEnabled(newValue);
    onChange(newValue); // Ensure onChange is called with the updated state
  };

  return (
    <div 
      className="w-full max-w-md mx-auto rounded-full flex items-center p-1 cursor-pointer border-2 border-[#EAEAEA]  transition-all duration-300"
      onClick={handleToggle}
    >
      <div className="flex rounded-full w-full">
        <div 
          className={`flex-1 py-1 px-2 text-center rounded-full transition-all duration-300 text-[10px] font-poppins ${
            enabled ? 'bg-indigo-600 text-white' : 'bg-transparent text-gray-700'
          }`}
        >
          Active
        </div>
        <div 
          className={`flex-1 py-1 px-2 text-center rounded-full transition-all duration-300 text-[10px] font-poppins ${
            !enabled ? 'bg-indigo-600 text-white' : 'bg-transparent text-gray-700'
          }`}
        >
          Inactive
        </div>
      </div>
    </div>
  );
};

export default ToggleActive;
